// extracted by mini-css-extract-plugin
module.exports = {"sectionFilters":"SectionFilters_sectionFilters__iL_wZ","inner":"SectionFilters_inner__Wk8Tq","aside":"SectionFilters_aside__pJD0i","total":"SectionFilters_total__Zfc_u"};